import { render, staticRenderFns } from "./AddFamilyMember.vue?vue&type=template&id=2f10f48a&scoped=true"
import script from "./AddFamilyMember.vue?vue&type=script&lang=ts"
export * from "./AddFamilyMember.vue?vue&type=script&lang=ts"
import style0 from "./AddFamilyMember.vue?vue&type=style&index=0&id=2f10f48a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f10f48a",
  null
  
)

export default component.exports